import { BASE_URL } from './config'

async function fetchWithHandling(url: string, options: RequestInit) {
  const response = await fetch(url, options)
  if (!response.ok) {
    let errorMessage = 'An error occurred'
    try {
      const errorData = await response.json()
      errorMessage = errorData.message || errorMessage
    } catch (e) {
      errorMessage = response.statusText
    }
    throw new Error(errorMessage)
  }
  return response.json()
}

export async function registerDevice(token: string, deviceUid: string) {
  return fetchWithHandling(`${BASE_URL}/api/v1/devices/register`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ deviceUid }),
  })
}

export async function getDeviceStatus(token: string, deviceUid: string) {
  return fetchWithHandling(
    `${BASE_URL}/api/v1/devices/status?deviceUid=${deviceUid}`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  )
}

export async function getMyDevices(token: string) {
  return fetchWithHandling(`${BASE_URL}/api/v1/devices/mine`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}

export async function resetDevice(token: string, deviceUid: string) {
  return fetchWithHandling(`${BASE_URL}/api/v1/devices/${deviceUid}/reset`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
}

export async function getCameraStream(token: string, deviceId: string) {
  return fetchWithHandling(
    `${BASE_URL}/api/v1/devices/${deviceId}/camera-stream`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  )
}
